var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M18.9006 10.6L12.6006 4.3L15.6006 1.3C16.0006 0.9 16.5006 0.9 16.9006 1.3L21.9006 6.3C22.3006 6.7 22.3006 7.2 21.9006 7.6L18.9006 10.6Z",
    fill: "#7FBB51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 21.5H2.6002C2.1002 21.5 1.7002 21.1 1.7002 20.6V15.5C1.7002 15.3 1.8002 15 2.0002 14.9L15.6002 1.3C16.0002 0.9 16.5002 0.9 16.9002 1.3L21.9002 6.3C22.3002 6.7 22.3002 7.2 21.9002 7.6L8.0002 21.5Z",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6006 4.2998L18.9006 10.5998",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 21.5H8",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f8cb519cf51adf389ca100073fc0d96e.svg";
export { ForwardRef as ReactComponent };